var exports = {
  "TS": "x234b8571--763b3d--rate",
  "wm": "x234b8571--763b3d--logo",
  "nM": "x234b8571--763b3d--row",
};

module.exports = exports;
